import React, { useContext } from 'react';
import { isEmpty, find, compact } from 'lodash';
import { routes } from 'constants/config';
import eyeIcon from 'images/eye.svg';
import { FilterContext } from 'components/shared/FilterContext/index';
import LessonActivityRow from './LessonActivityRow';
import WeeklyLessonViewsChart from './WeeklyLessonViewsChart';
import DataCardHeader from '../_shared/DataCardHeader';
import Count from '../_shared/Count';
import DataCardTitle from '../_shared/DataCard/Title';
import InsightsTable from '../_shared/InsightsTable';
import { formatDateRange } from '../_shared/DateRangeFormat';

const LessonViewsModule = ({ i18n }) => {
  const { params: filters } = useContext(FilterContext);
  const hasDateFilter = filters.start_date || filters.end_date;
  const hasGroupsFilter = !isEmpty(filters.group_ids);

  const withFilterQuery = url => compact([url, $.param(filters)]).join('?');

  const dailyViewsTooltip = find([
    hasDateFilter &&
      hasGroupsFilter &&
      t('insights.lesson_views.daily_views.description_with_all_filters'),
    hasDateFilter &&
      !hasGroupsFilter &&
      t('insights.lesson_views.daily_views.description_with_date_filter'),
    !hasDateFilter &&
      hasGroupsFilter &&
      t('insights.lesson_views.daily_views.description_with_groups_filter'),
    t('insights.lesson_views.daily_views.description'),
  ]);

  const mostViewedTooltip = find([
    hasDateFilter &&
      t('insights.lesson_views.most_viewed.description_with_date_filter'),
    t('insights.lesson_views.most_viewed.description'),
  ]);

  const weeklyViewedTooltip = find([
    hasDateFilter &&
      hasGroupsFilter &&
      t('insights.lesson_views.weekly_views.description_with_all_filters'),
    hasDateFilter &&
      !hasGroupsFilter &&
      t('insights.lesson_views.weekly_views.description_with_date_filter'),
    !hasDateFilter &&
      hasGroupsFilter &&
      t('insights.lesson_views.weekly_views.description_with_groups_filter'),
    t('insights.lesson_views.weekly_views.description'),
  ]);

  const dateRangeSubtitle = hasDateFilter
    ? formatDateRange(filters.start_date, filters.end_date)
    : i18n.timeframes.last_90_days;

  return (
    <section className="DataCard mb-24">
      <DataCardHeader
        title={i18n.lesson_views.daily_views.title}
        subtitle={dateRangeSubtitle}
        tooltip={dailyViewsTooltip}
      >
        <Count
          imgSrc={eyeIcon}
          imgDescription={`${i18n.lesson_views.icon.description}:`}
          route={routes.INSIGHTS.LESSON_VIEWS.COUNT}
        />
      </DataCardHeader>
      <div className="DataCard-main">
        <DataCardTitle
          title={i18n.lesson_views.weekly_views.title}
          tooltip={weeklyViewedTooltip}
          subtitle={dateRangeSubtitle}
        />
        <WeeklyLessonViewsChart i18n={i18n} />
        <InsightsTable
          title={i18n.lesson_views.most_viewed.title}
          tooltip={mostViewedTooltip}
          subtitle={dateRangeSubtitle}
          source={withFilterQuery(
            routes.INSIGHTS.LESSON_VIEWS.MOST_ACTIVE_LESSONS,
          )}
          rowComponent={LessonActivityRow}
          i18n={i18n}
          customClass="mt-32"
        />
      </div>
    </section>
  );
};

export default LessonViewsModule;
